var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AccountPropertySection',_vm._b({attrs:{"placeholder":_vm.randomPronounsPlaceholder}},'AccountPropertySection',_vm.pronouns,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }